module.exports = __webpack_public_path__ + "img/menu_back.82bd7a01.svg";